import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import orgReducer from "./slices/orgSlice";
import teamReducer from "./slices/teamSlice";
import uiReducer from "./slices/uiSlice";
import authReducer from "./authSlice";
import profileReducer from "./profileSlice";
import sidebarReducer from "./sidebarSlice";
import walletReducer from "./slices/walletSlice";
import notificationsReducer from "./slices/notificationSlice";
import activityReducer from "./slices/activitySlice";
import tooltipReducer from "./slices/tooltipSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    organization: orgReducer,
    team: teamReducer,
    ui: uiReducer,
    auth: authReducer,
    profile: profileReducer,
    sidebar: sidebarReducer,
    wallet: walletReducer,
    notifications: notificationsReducer,
    activity: activityReducer,
    tooltip: tooltipReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
